import _ from 'lodash';
import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.HiddenCustomers',
    modules: [
        R,
    ],
})
@Service('HiddenCustomersStore')
export default class Store extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('hidden-customers');
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/hiddenCustomers.js